import { SVGProps } from 'react'

export const CopyLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.6665 13.3333V15.6666C6.6665 16.6 6.6665 17.0668 6.84816 17.4233C7.00795 17.7369 7.26292 17.9918 7.57652 18.1516C7.93304 18.3333 8.39975 18.3333 9.33317 18.3333H15.6665C16.5999 18.3333 17.0666 18.3333 17.4232 18.1516C17.7368 17.9918 17.9917 17.7369 18.1515 17.4233C18.3332 17.0668 18.3332 16.6 18.3332 15.6666V9.33329C18.3332 8.39987 18.3332 7.93316 18.1515 7.57664C17.9917 7.26304 17.7368 7.00807 17.4232 6.84828C17.0666 6.66663 16.5999 6.66663 15.6665 6.66663H13.3332M4.33317 13.3333H10.6665C11.5999 13.3333 12.0666 13.3333 12.4232 13.1516C12.7368 12.9918 12.9917 12.7369 13.1515 12.4233C13.3332 12.0668 13.3332 11.6 13.3332 10.6666V4.33329C13.3332 3.39987 13.3332 2.93316 13.1515 2.57664C12.9917 2.26304 12.7368 2.00807 12.4232 1.84828C12.0666 1.66663 11.5999 1.66663 10.6665 1.66663H4.33317C3.39975 1.66663 2.93304 1.66663 2.57652 1.84828C2.26292 2.00807 2.00795 2.26304 1.84816 2.57664C1.6665 2.93316 1.6665 3.39987 1.6665 4.33329V10.6666C1.6665 11.6 1.6665 12.0668 1.84816 12.4233C2.00795 12.7369 2.26292 12.9918 2.57652 13.1516C2.93304 13.3333 3.39975 13.3333 4.33317 13.3333Z"
      stroke="#0074DD"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
